import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Send } from 'lucide-react';
import './ForArtistsTeaser.css';

const ForArtistsTeaser = () => {
  return (
    <section className="for-artists-teaser">
      <div className="teaser-bg">
        <img 
          src="https://images.pexels.com/photos/5749200/pexels-photo-5749200.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" 
          alt="Music producer in studio"
          className="teaser-bg-image"
        />
        <div className="teaser-overlay"></div>
      </div>
      
      <div className="container">
        <div className="teaser-content fade-in">
          <span className="section-label">For Artists</span>
          <h2>If your music belongs in this world, we want to hear it</h2>
          <p>
            AMR works with artists building electronic music with clarity, character, and long-term potential. 
            We support releases with strategy, visuals, rollout planning, and club-facing positioning across 
            streaming and Beatport.
          </p>
          <div className="teaser-ctas">
            <Link to="/for-artists" className="btn btn-primary">
              For Artists <ArrowRight size={18} />
            </Link>
            <Link to="/submit-demo" className="btn btn-secondary">
              <Send size={18} /> Submit Music
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForArtistsTeaser;
